/*
 * 中央控制台
 * 服务端提供的路径
 */

const path = {
  login: 'user/login', // 登录
  imageUpload: 'common/file/imageUpload', // 图片上传
  commonUpload: 'common/file/upload', // 公用上传文件

  /** ************* 客户管理 ***********************************************/
  queryRegisterUserById: 'center/queryRegisterUserById', // 获取客户信息

  queryRegisterUserList: 'registerUser/queryRegisterUserList', // 获取注册客户列表
  centerAdoptAccount: 'registerUser/adoptAccount', // 审批注册客户
  centerPullBlacklist: 'registerUser/pullBlacklist', // 拉入黑名单
  centerDelCompanyUser: 'registerUser/delCompanyUser', // 删除客户
  queryCommodityList: 'commodity/queryCommodityList', // 获取客户功能权限列表
  saveCommodityByUser: 'commodity/saveCommodityByUser', // 修改客户功能权限
  getDefaultCommodityList: 'commodity/getDefaultCommodityList', // 获取默认功能列表

  queryTrialUserList: 'trialUser/queryTrialUserList', // 获取试用客户列表
  saveTrialUser: 'trialUser/saveTrialUser', // 保存试用客户
  editTrialUser: 'trialUser/editTrialUser', // 编辑试用客户
  updateTrialCustomerUser: 'trialUser/updateTrialCustomerUser', // 试用客户转移责任人
  updateTrialToFormalUser: 'trialUser/updateTrialToFormalUser', // 试用客户转为正式客户
  TenableDisableUser: 'trialUser/enableDisableUser', // 启用/禁用试用客户
  delTrialUser: 'trialUser/delTrialUser', // 删除试用客户
  batchModifyTrialUser: 'trialUser/batchModifyCustomerInfo', // 试用客户-批量处理客户

  saveFormalUser: 'formalUser/saveFormalUser', // 添加正式客户
  queryFormalUserList: 'formalUser/queryFormalUserList', // 正式客户列表
  queryAllFormalUsers: 'formalUser/queryAllFormalUsers', // 获取所有正式客户列表
  editFormalUser: 'formalUser/editFormalUser', // 编辑正式客户
  updateFormalUserCustomer: 'formalUser/updateFormalUserCustomer', // 转移正式客户负责人
  delFormalUser: 'formalUser/delFormalUser', // 删除正式客户
  FenableDisableUser: 'formalUser/enableDisableUser', // 启用/禁用正式客户
  saveCustomerCommodity: 'formalUser/saveCustomerCommodity', // 修改客户功能权限2
  getCustomerCommodityList: 'formalUser/getCustomerCommodityList', // 修改客户功能权限2
  batchModifyFormalUser: 'formalUser/batchModifyCustomerInfo', // 正式客户-批量处理客户

  saveCustomerAuditRegulation: 'customerAuditRegulation/saveCustomerAuditRegulation', // 保存免审批规则
  editCustomerAuditRegulation: 'customerAuditRegulation/editCustomerAuditRegulation', // 编辑免审批规则
  enableDisableCustomerAuditRegulation: 'customerAuditRegulation/enableDisableCustomerAuditRegulation', // 启用禁用规则
  deleteCustomerAuditRegulation: 'customerAuditRegulation/deleteCustomerAuditRegulation', // 删除规则
  queryCustomerAuditRegulationList: 'customerAuditRegulation/queryCustomerAuditRegulationList', // 免审批列表
  /** **********END******************************************************/

  /** ************* 业务管理 ***********************************************/
  saveAdditional: 'additional/saveAdditional', // 添加增购
  queryAdditionalList: 'additional/queryAdditionalList', // 增购列表
  delAdditional: 'additional/delAdditional', // 删除增购信息
  queryAdditionalListByFormalUser: 'additional/queryAdditionalListByFormalUser', // 获取正式客户增购列表
  queryAdditionalById: 'additional/queryAdditionalById', // 获取正式客户增购列表

  saveReduction: 'reduction/saveReduction', // 新增减购
  queryReductionList: 'reduction/queryReductionList', // 减购列表
  delReduction: 'reduction/delReduction', // 删除减购
  queryReductionListByFormalUser: 'reduction/queryReductionListByFormalUser', // 获取正式客户减购列表

  saveRenewal: 'renewal/saveRenewal', // 新增续费
  editRenewal: 'renewal/editRenewal', // 编辑续费
  delRenewal: 'renewal/delRenewal', // 删除续费
  queryRenewalList: 'renewal/queryRenewalList', // 续费列表
  queryRenewalListByFormalUser: 'renewal/queryRenewalListByFormalUser', // 获取正式客户续费列表
  queryRenewalOrderTimeList: 'renewal/queryRenewalOrderTimeList', // 获取客户续费套餐时间

  getAllRenewList: '/renew/getAllRenewList', // 续费订单列表

  saveChargingStrategy: 'chargingStrategy/saveChargingStrategy', // 添加收费策略
  editChargingStrategy: 'chargingStrategy/editChargingStrategy', // 编辑收费策略
  enableDisableChargingStrategy: 'chargingStrategy/enableDisableChargingStrategy', // 禁用/启用收费策略
  delChargingStrategy: 'chargingStrategy/delChargingStrategy', // 删除收费策略
  queryAllChargingStrategy: 'chargingStrategy/queryAllChargingStrategy', // 获取收费策略列表(应用于正式客户新增时版本选取)
  queryChargingStrategyList: 'chargingStrategy/queryChargingStrategyList', // 收费策略列表
  queryVersionCommodityByVersion: 'chargingStrategy/queryVersionCommodityByVersion', // 获取收费策略功能清单
  saveCommodityByVersion: 'chargingStrategy/saveCommodityByVersion', // 修改收费策略的功能清单
  queryFormalUserListByCSID: 'formalUser/queryFormalUserListByCSID', // 获取消费策略的客户列表

  saveInvite: 'invite/saveInvite', // 生成邀请码
  editInvite: 'invite/editInvite', // 编辑邀请码
  delInviteCode: 'invite/delInviteCode', // 删除邀请码
  queryInviteList: 'invite/queryInviteList', // 邀请码列表
  queryFormalUserListByInviteId: 'formalUser/queryFormalUserListByInviteId', // 邀请码 客户

  getAllComponentList: 'componentManage/getAllComponentList', // 获取高级组件和基础组件
  getComponentManageList: 'componentManage/getComponentManageList', // 组件管理 列表
  saveComponentManage: 'componentManage/saveComponentManage', // 组件管理 保存
  getComponentList: 'componentManage/getComponentList', // 组件管理 获取字段
  updateComponentManage: 'componentManage/updateComponentManage', // 组件管理 修改
  getComponentManageDetail: 'componentManage/getComponentManageDetail', // 组件管理 详情
  delComponentManage: 'componentManage/delComponentManage', // 组件管理
  getEnableComponentManageList: 'componentManage/getEnableComponentManageList', // 组件管理 列表2

  saveThirdParty: 'third/party/setmeal/purchase/save', // 第三方对照表 新增或更新
  findThirdParty: 'third/party/setmeal/purchase/findALL', // 第三方对照表 列表
  deleteThirdParty: 'third/party/setmeal/purchase/delete', // 第三方对照表 删除
  /** **********END******************************************************/

  /** ************* 应用管理 ***********************************************/
  editApplication: 'controlApplication/editApplication', // 应用详情编辑

  queryApplicationList: 'controlApplication/queryApplicationList', // 获取待审核应用列表
  findApplicationById: 'controlApplication/findApplicationById', // 应用详情请求
  deleteApplication: 'controlApplication/deleteApplication', // 删除应用(已发布、待发布)
  approvalApplication: 'controlApplication/approvalApplication', // 待审批应用审核 11111
  queryReleaseApplicationList: 'controlApplication/queryReleaseApplicationList', // 获取已发布应用列表
  editNonsuchApplication: 'controlApplication/editNonsuchApplication', // 设为精品应用（排序）
  editApplicationNumber: 'controlApplication/editApplicationNumber', // 管理下载次数
  updateApplication: 'controlApplication/updateApplication', // 已发布应用更改 11111
  updateApplicationVersion: 'controlApplication/updateApplicationVersion', // 可安装版本设置
  deleteReleaseApplication: 'controlApplication/deleteReleaseApplication', // 删除已发布应用 11111
  updateNonsuchApplication: 'controlApplication/updateNonsuchApplication', // 应用的编辑保存
  queryNonsuchApplicationList: 'controlApplication/queryNonsuchApplicationList', // 获取精品应用列表
  removeNonsuchApplication: 'controlApplication/removeNonsuchApplication', // 移除精品应用
  queryAssemblyAndVersion: 'controlApplication/queryAssemblyAndVersion', // 获取上一次选择的版本和组件
  applicationChargeBillRecordList: 'applicationChargeBillRecord/list', // 获取上一次选择的版本和组件
  updatePaymentStatusById: 'applicationChargeBillRecord/updatePaymentStatusById', // 获取上一次选择的版本和组件
  applicationChargeBillRecordExport: 'applicationChargeBillRecord/export', // 获取上一次选择的版本和组件
  appClassifyList: 'applicationTemplate/classify/list', // 应用分类 - 获取
  appClassifySave: 'applicationTemplate/classify/save', // 应用分类 - 保存
  appClassifyDel: 'applicationTemplate/classify/delete', // 应用分类 - 删除
  appClassifySort: 'applicationTemplate/classify/updateSort', // 应用分类 - 排序
  queryAuthorizationCodeUserCountList: 'applicationAuthorizationCode/queryAuthorizationCodeUserCountList', // 授权码
  saveAuthorizationCode: 'applicationAuthorizationCode/saveAuthorizationCode', // 授权码
  deleteAuthorizationCode: 'applicationAuthorizationCode/deleteAuthorizationCode', // 授权码
  /** **********END******************************************************/

  /** ************* 发布管理 ***********************************************/
  addReleaseNotice: 'releaseNotice/addReleaseNotice', // 新增公告
  modifyReleaseNotice: 'releaseNotice/modifyReleaseNotice', // 编辑公告
  deleteReleaseNotice: 'releaseNotice/deleteReleaseNotice', // 删除公告
  queryReleaseNoticeList: 'releaseNotice/queryReleaseNoticeList', // 获取公告列表
  /** ************* 发布管理END ***********************************************/

  /** ************* 新闻中心START ***********************************************/
  newsQueryNewType: 'news/queryNewType', // 获取新闻分类列表
  newsQueryNewsList: 'news/queryNewsList', // 获取新闻列表
  newsDeleteNews: 'news/deleteNews', // 删除新闻
  newsUpdateNewsStatus: 'news/updateNewsStatus', // 修改发布状态
  newsAddNews: 'news/addNews', // 新增新闻
  webNewsQueryNewsDetail: 'webNews/queryNewsDetail', // 获取新闻详情
  newsUpdateNews: 'news/updateNews', // 获取新闻详情
  newsAddNewsType: 'news/addNewsType', // 新增新闻分类
  newsUpdateNewsType: 'news/updateNewsType', // 编辑新闻分类
  newsDeleteNewsType: 'news/deleteNewsType', // 删除新闻分类
  newsUpdateNewsTypeSort: 'news/updateNewsTypeSort', // 新闻分类排序
  topNews: 'news/topNews', // 置顶/取消置顶
  /** ************* 新闻中心END ***********************************************/

  /** ************* 帮助中心START ***********************************************/
  helpCenterAddMenu: 'helpCenter/addMenu', // 添加菜单
  queryMenuList: 'webHelpCenter/menu/queryMenuList', // 获取菜单
  updateMenu: 'helpCenter/updateMenu', // 编辑菜单
  deleteMenu: 'helpCenter/deleteMenu', // 删除菜单
  swapMenuSort: 'helpCenter/swapMenuSort', // 菜单排序
  queryDocList: 'webHelpCenter/doc/queryDocList', // 获取视频菜单详情列表
  addDoc: 'helpCenter/doc/addDoc', // 新增数据
  updateDoc: 'helpCenter/doc/updateDoc', // 修改数据
  deleteDoc: 'helpCenter/doc/deleteDoc', // 删除数据
  updateDocSort: 'helpCenter/doc/updateDocSort', // 详情列表排序
  /** ************* 帮助中心END ***********************************************/

  /** ************* 平台管理 ***********************************************/
  queryUserList: 'user/queryUserList', // 获取账号管理列表
  savaUser: 'user/savaUser', // 新增账号管理
  editUser: 'user/editUser', // 编辑账号管理
  delUser: 'user/delUser', // 删除账号管理
  enableDisableUser: 'user/enableDisableUser', // 禁用/启用用户
  editPwd: 'user/editPwd', // 修改密码

  queryFchBtnAuth: 'role/queryFchBtnAuth', // 获取功能权限
  queryRoleList: 'role/queryRoleList', // 获取角色分组
  queryRoleUser: 'role/queryRoleUser', // 获取角色用户
  modifyAuthByRole: 'role/modifyAuthByRole', // 修改角色权限
  queryRoleAuth: 'role/queryRoleAuth', // 获取角色权限
  addRole: 'role/addRole', // 添加角色
  modifyRole: 'role/modifyRole', // 修改角色
  deleteRole: 'role/deleteRole', // 删除角色
  queryInitRoleAuth: 'role/queryInitRoleAuth', // 获取初始化数据表
  getUserByRole: 'role/getUserByRole', // 获取角色用户
  savaRoleAccount: 'role/savaRoleAccount', // 保存角色用户

  queryRecordList: 'userOperator/queryRecordList', // 获取日志列表
  /** **********END******************************************************/

  /** ************* APP版本 ***********************************************/
  saveVersionInfo: 'android/saveVersionInfo', // 添加Android版本接口
  getVersionList: 'android/getVersionList', // 获取Android版本列表接口
  updateVersionInfo: 'android/updateVersionInfo', // 修改Android版本接口
  delVersionInfo: 'android/delVersionInfo', // 删除Android版本信息接口
  /** **********END******************************************************/

  /** ************* 运营管理 ***********************************************/
  queryDataembeddingpointList: 'dataembeddingpoint/queryDataembeddingpointList', // 数据埋点列表
  dataEmbeddingpointExport: 'dataembeddingpoint/dataEmbeddingpointExport', // 导出数据埋点列表

  /** ************* 监测 ***********************************************/
  getLocalMonitorList: 'localMonitor/getLocalMonitorList', // 获取列表
  startMonitorCompany: 'localMonitor/startMonitorCompany', // 获取列表
  /** **********END******************************************************/

  /** ************* 名片小程序 ***********************************************/
  getBusinessCardList: 'businessCard/getBusinessCardList', // 获取名片列表接口
  enableDisableCard: 'businessCard/enableDisableCard' // 启用/禁用名片接口
  /** **********END******************************************************/

}
export default path



// WEBPACK FOOTER //
// ./src/common/js/port.js